<section>
  <app-list-view
    [columnDefinition]="columnDefinitions"
    [contextMenuDefinition]="contextMenuDefinitions"
    [itemsSource]="items"
    [preferencesKey]="'invoice.amortization-plan.documents.list'"
    [contextId]="contextId"
    (rowClick)="onRowClicked($event)"
  ></app-list-view>
</section>
